import { SupportedLanguage, SUBSCRIBE_MAIL } from '@/constants';
import { PHASE } from '@/constants/env';

export const subscribeMail = async (
  data: string,
  language: SupportedLanguage,
) => {
  const subscribeLink = SUBSCRIBE_MAIL[PHASE].api[language];

  await fetch(subscribeLink, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: data,
    mode: 'no-cors',
  });
};
